var objTicketValidation = {
    // <summary>
    // This object holds all functions for data validation related functionality in ticket.js
    // </summary>
    _validate: function (me) {
        /// <summary>
        ///  This function validates different values and states <br/>
        /// It marks invalid items and activates/deactivates the info box with the save button
        /// </summary>
        var bError = false;
        var text = "";
        try {
         
            if (me.error) { return false; }
            if (me.initState) return true;
            if (me.readOnlyMode) return true;


            if (me.myHtml.rowMain.infoBox.txtName.val().length === 0) {
                me.myHtml.rowMain.infoBox.txtName.removeClass("error").addClass("error");
                text += "* " + me.specific.resources.inputIncomplete + "<br/>";
                bError = true;
            } else {
                if (me.myHtml.rowMain.infoBox.txtName.val().length > 75) {
                    me.myHtml.rowMain.infoBox.txtDescription.removeClass("error").addClass("error");
                    text += "* " + me.specific.resources.nameTooLong + "<br/>";
                    bError = true;
                } else {
                    me.myHtml.rowMain.infoBox.txtName.removeClass("error");
                }
            }

            //validate the start date and proper time intervals
            if (me.myHtml.rowMain.infoBox.divDateStart.hasClass("vc-date")) {
                var start = me.myHtml.rowMain.infoBox.divDateStart.vcDate("getDate").from;
                start = window.moment(start, "DD.MM.YYYY");

                /*  var completion = me.myHtml.rowMain.infoBox.divDateCompletion.vcDate("getDate").from;*/
              
                if (!me.myHtml.rowMain.infoBox.dateCompletion.divDate.hasClass("vc-date")) {
                    text += "* " + me.specific.resources.enterEndDate + "<br/>";
                    bError = true;
                }

                //console.info(me.myHtml.rowMain.infoBox.dateCompletion.txtDate.val());
                //if (me.myHtml.rowMain.infoBox.dateCompletion.txtDate.val().length == 0) {
                //    text += "* " + "NO COMPLETION DATE" + "<br/>";
                //    bError = true;
                //}

                if (!objTicketValidation._validateDate(me,start, me.myHtml.rowMain.infoBox.dateCompletion.divDate)) {
                    text += "* " + me.specific.resources.startBeforeEnd + "<br/>";
                    bError = true;
                }

                if (!objTicketValidation._validateDate(me, start, me.myHtml.rowUser.userBox.dateExecution.divDate)) {
                    text += "* " + me.specific.resources.startBeforeEnd + "<br/>";
                    bError = true;
                }
                if (!objTicketValidation._validateDate(me, start, me.myHtml.rowUser.userBox.dateValidation.divDate)) {
                    text += "* " + me.specific.resources.startBeforeEnd + "<br/>";
                    bError = true;
                }
            }

            //validate all empty dropdowns (except the validation user)
            if (objTicketValidation._validateSelectize(me,me.myHtml.rowMain.infoBox.ddlTasks, me.ddlTasks)) {
                if (text.indexOf(me.specific.resources.inputIncomplete) < 0) { text += "* " + me.specific.resources.inputIncomplete + "<br/>"; }
                bError = true;
            }

            if (objTicketValidation._validateSelectize(me, me.myHtml.rowMain.infoBox.ddlPriority, me.ddlPriorities)) {
                if (text.indexOf(me.specific.resources.inputIncomplete) < 0) { text += "* " + me.specific.resources.inputIncomplete + "<br/>"; }
                bError = true;
            }

            if (objTicketValidation._validateSelectize(me, me.myHtml.rowMain.infoBox.ddlScope, me.ddlScope)) {
                if (text.indexOf(me.specific.resources.inputIncomplete) < 0) { text += "* " + me.specific.resources.inputIncomplete + "<br/>"; }
                bError = true;
            }
            if (objTicketValidation._validateSelectize(me, me.myHtml.rowMain.infoBox.ddlState, me.ddlStates)) {
                if (text.indexOf(me.specific.resources.inputIncomplete) < 0) { text += "* " + me.specific.resources.inputIncomplete + "<br/>"; }
                bError = true;
            }

            if (objTicketValidation._validateSelectize(me, me.myHtml.rowMain.assignmentBox.ddlLogger, me.ddlLogger)) {
                text += "* " + me.specific.resources.noLoggerSelected + "<br/>";
                bError = true;
            }
            if (objTicketValidation._validateSelectize(me, me.myHtml.rowUser.userBox.ddlOwner, me.ddlOwner)) {
                text += "* " + me.specific.resources.noOwnerSelected + "<br/>";
                bError = true;
            }
            if (objTicketValidation._validateSelectize(me, me.myHtml.rowUser.userBox.ddlExecutor, me.ddlExecutor)) {
                text += "* " + me.specific.resources.noExecutorSelected + "<br/>";
                bError = true;
            }

            ////validate dates for the different states
            ////*******
            ////remove all error classes
            me.fnd("#div-date-execution .caption, #div-date-validation .caption").removeClass("err");

            //in validation-state the execution date must not be empty
            if (parseInt(me.ddlStates.getValue()) === me.specific.STATE_VALIDATION_TYPEID) {
                if (!me.myHtml.rowUser.userBox.dateExecution.divDate.hasClass("vc-date")) {
                    text += "* " + me.specific.resources.processNotFinished + "<br/>";
                    me.myHtml.rowUser.userBox.dateExecution.caption.addClass("err");
                    bError = true;
                }
            }

            //validate done-state
            if (parseInt(me.ddlStates.getValue()) === me.specific.STATE_DONE_TYPEID) {
                //error if both dates are empty
                if (!me.myHtml.rowUser.userBox.dateExecution.divDate.hasClass("vc-date") &&
                    !me.myHtml.rowUser.userBox.dateValidation.divDate.hasClass("vc-date")) {
                    text += "* " + me.specific.resources.processNotFinished + "<br/>";
                    me.myHtml.rowUser.userBox.dateExecution.caption.addClass("err");
                    me.myHtml.rowUser.userBox.dateValidation.caption.addClass("err");
                    bError = true;
                }
                //if an validator exists but no date
                if (me.ddlValidator.getValue().length > 0) {
                    if (!me.myHtml.rowUser.userBox.dateValidation.divDate.hasClass("vc-date")) {
                        text += "* " + me.specific.resources.processNotFinished + "<br/>";
                        me.myHtml.rowUser.userBox.dateValidation.caption.addClass("err");
                        bError = true;
                    }
                }
            }

            if (parseInt(me.ddlStates.getValue()) === me.specific.STATE_NON_BILLABLE_TYPEID) {
                me.myHtml.topMenu.btnAccounting.hide();
            }
            else {
                if (me.specific.isStaff === "true")
                    me.myHtml.topMenu.btnAccounting.show();
            }


            if (me.assignmentType === me.specific.ASSIGNMENT_SIGNAL_TYPEID) {
                //no signals got selected
                if (me.myHtml.rowMain.assignmentBox.signalList.is(":visible")) {
                    if (me.fnd("#div-signals .chb-signals:checked").length === 0) {
                        text += "* " + me.specific.resources.noSignalsSelected + "<br/>";
                        bError = true;
                    }
                }
            }

            //no unit got selected
            me.myHtml.rowMain.assignmentBox.ddlUnit.removeClass("error");

            if (me.myHtml.rowMain.assignmentBox.ddlUnit.is(":visible")) {
                if (me.ddlUnit === null) {
                    text += "* " + me.specific.resources.noUnitSelected + "<br/>";
                    me.myHtml.rowMain.assignmentBox.ddlUnit.addClass("error");
                    bError = true;
                } else {
                    if (objTicketValidation._validateSelectize(me, me.myHtml.rowMain.assignmentBox.ddlUnit, me.ddlUnit)) {
                        text += "* " + me.specific.resources.noUnitSelected + "<br/>";
                        bError = true;
                    }
                }
            }

            //reset/prepare the info box
            me.myHtml.topMenu.state.removeClass("error clear");
            me.myHtml.topMenu.btnSave.button("disable");
            me.myHtml.topMenu.btnSaveClose.button("disable");
            me.myHtml.topMenu.errors.html("");



            if (bError) {
                me.myHtml.topMenu.errors.html(text).show();
                me.myHtml.topMenu.state.addClass("error");

            } else {
                //don't activate the save button while init state
                if (me.fnd("#div-entry .dirty").length > 0) {
                    // save & close always allowed in edit mode
                    me.myHtml.topMenu.btnSaveClose.button("enable");

                    // only save is only allowed if ticket exists
                    if (me.entry && me.entry.Id && me.entry.Id > 0) me.myHtml.topMenu.btnSave.button("enable");
                    else me.myHtml.topMenu.btnSave.button("disable");
                }
            }

            return true;
        } catch (ex) { me._writeErr(ex); return false; }

    },

    _validateSelectize: function (me, obj, ddl) {
        /// <summary>
        ///  This function switches between the readonly and the edit mode
        /// </summary>
        try {
            if (me.error) { return false; }

            if (obj.is(":visible")) {
                if (ddl.getValue().length === 0) {
                    obj.parents(".type-select").addClass("error");
                    return true;
                } else {
                    obj.parents(".type-select").removeClass("error");
                    return false;
                }
            }
            return false;
        } catch (ex) { me._writeErr(ex); return true; }

    },


    _validateDate: function (me, start, obj) {
        /// <summary>
        ///  This function ...
        /// </summary>
        try {

            if (me.error) { return false; }

            if (obj.hasClass("vc-date")) {
                let dt = window.moment(obj.vcDate("getDate").from, "DD.MM.YYYY");
                if (window.moment.duration(dt.diff(start)).asDays() < 0) {
                    return false;
                }
            }

            return true;
        } catch (ex) { me._writeErr(ex); return false; }

    }
};